import type { Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

/**
 * Largeur max commune pour affiche + blocs hero (évite l’effet « entonnoir »
 * entre une affiche étroite et un bandeau plus large).
 */
export const HOME_HERO_MAX_WIDTH_PX = 560;

/** Carte hero pré-ouverture (affiche + infos) : aligner les blocs sous-jacents sur cette largeur. */
export const HOME_PREOPEN_CARD_MAX_WIDTH_PX = 680;

/** Week-end de compétition (cohérent avec l’affiche officielle). */
export const HOME_EVENT_WEEKEND_LINE = "31 octobre et 1er novembre 2026";

/** Ligne marketing dotations (affiche — pas un tarif d’inscription). */
export const HOME_EVENT_DOTATIONS_LINE = "2 610 € de dotations";

/** Fallbacks « Pourquoi participer ? » (site A / tournoi national). */
export const HOME_WHY_PARTICIPATE_ORGANIZATION =
  "32 tables, pointage et fluidité pour enchaîner les matchs dans les meilleures conditions.";
export const HOME_WHY_PARTICIPATE_LEVELS =
  "Plusieurs séries pour que chacun trouve sa place, du loisir aux compétiteurs. Récompenses jusqu'à 350€ pour les vainqueurs.";
export const HOME_SPECTATOR_TABLES_LINE =
  "32 tables et buvette sur place — venez encourager les participants !";

/**
 * Heure d’ouverture des inscriptions affichée côté public (heure de Paris).
 * À ajuster ici si le créneau change ; la date reste portée par Firestore.
 */
export const HOME_REGISTRATION_OPEN_TIME_LABEL = "12 h";

export const homeHeroColumnSx = {
  width: "100%",
  maxWidth: HOME_HERO_MAX_WIDTH_PX,
  mx: "auto",
} as const;

/**
 * Carte Paper partagée : hero pré-ouverture (haut) et hero inscriptions ouvertes.
 */
export function getHomeRegistrationHeroPaperSx(theme: Theme) {
  const isDark = theme.palette.mode === "dark";
  return {
    width: "100%",
    maxWidth: HOME_PREOPEN_CARD_MAX_WIDTH_PX,
    mx: "auto",
    mb: { xs: 3, md: 3.5 },
    p: { xs: 2.75, sm: 3.75, md: 4 },
    borderRadius: { xs: 3, md: 4 },
    border: `1px solid ${alpha(
      theme.palette.primary.main,
      isDark ? 0.38 : 0.22
    )}`,
    background: isDark
      ? `linear-gradient(
                  152deg,
                  ${alpha(theme.palette.primary.main, 0.18)} 0%,
                  ${alpha(theme.palette.background.paper, 0.97)} 48%,
                  ${theme.palette.background.paper} 100%
                )`
      : `linear-gradient(
                  152deg,
                  ${alpha(theme.palette.primary.light, 0.5)} 0%,
                  ${theme.palette.background.paper} 52%
                )`,
    boxShadow: isDark
      ? "0 10px 36px rgba(0,0,0,0.4)"
      : "0 14px 44px rgba(30, 60, 120, 0.1)",
  };
}

/** Photos galerie : fichiers dans public/home-gallery/ */
export const GALLERY_IMAGES = [
  "/home-gallery/home-gallery-salle.png",
  "/home-gallery/home-gallery-buvette.png",
  "/home-gallery/home-gallery-3.jpg",
];
